import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
    name: 'ServiceFunctionDetailSoundBroadcast',
    components: {
        Loading
    },
    data () {
        return {
            loading: true,
            processing: false,
            activeFilters: false,
            filterPerPage: Constants.TablePerPageInitial,
            tableColumns: [
                'word',
                'ruby',
                'modifyButton',
                'deleteButton'
            ],
            tableData: [],
            tableOptions: {
                headings: {
                    word: '単語',
                    ruby: '読み方',
                    modifyButton: '',
                    deleteButton: ''
                },
                columnsClasses: {
                    word: '',
                    ruby: '',
                    modifyButton: 'wp-5 has-button',
                    deleteButton: 'wp-5 has-button'
                },
                sortable: [
                    'word',
                    'ruby',
                ],
                filterable: [],
                texts: Constants.TableOptions.getTexts('登録済み読み方'),
                perPage: Constants.TablePerPageInitial,
                perPageValues: Constants.TableOptions.perPageValues,
                pagination: Constants.TableOptions.pagination
            },
            // 変更
            modifyTargetId: null,
            deleteTargetId: null
        }
    },
    mounted () {
        this.init()
    },
    computed: {
        ...mapState({
            functionName: state => state.serviceFunctionDetail.functionName,
            // model
            noticeTypeMstModel: state => state.serviceFunctionDetail.noticeTypeMstModel,
            // form
            serviceUuid: state => state.serviceFunctionDetail.serviceId,
            serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
            values: state => state.serviceFunctionDetail.values,
            deliveryType: state => state.serviceFunctionDetail.deliveryType,
            // confirm
            confirmKey: state => state.confirm.key,
            confirmAccepted: state => state.confirm.accept
        }),
        ...mapGetters({
            isRegister: 'serviceFunctionDetail/isRegister',
        }),
        noticeTypeList () {
            return this.noticeTypeMstModel.map(item => {
                return {
                    value: item.noticeType,
                    label: item.noticeTypeName
                }
            })
        },
        inpNoticeTypes: {
            get () {
                return this.values.inpNoticeTypes
            },
            set (value) {
                this.setInputValue({
                    key: 'inpNoticeTypes',
                    value: value
                })
            }
        },
        formIsValid () {
            return Validator.validArray(this.inpNoticeTypes)
        },
        disableNoticeTypesButton () {
            return !this.formIsValid
        },
        formButtonNoticeTypesLabel () {
            return '登録'
        },
        formButtonDictionaryLabel () {
            return this.isRegister ? '登録' : '変更'
        },
        inpWord: {
            get () {
                return this.values.inpWord
            },
            set (value) {
                this.setInputValue({
                    key: 'inpWord',
                    value: value
                })
            }
        },
        inpRuby: {
            get () {
                return this.values.inpRuby
            },
            set (value) {
                this.setInputValue({
                    key: 'inpRuby',
                    value: value
                })
            }
        },
        inpWordIsValid () {
            return Validator.validText(this.inpWord)
        },
        inpRubyIsValid () {
            return Validator.validText(this.inpRuby)
        },
        formDictionaryValid () {
            return this.inpWordIsValid && this.inpRubyIsValid
        },
        disableDictionaryButton () {
            return !this.formDictionaryValid
        },
        tablePerPageList () {
            let list = []
            Constants.TablePerPage.forEach(item => list.push({
                value: item,
                label: item
            }))
            return list
        },
        showFilters () {
            return !this.isSmartPhone ||
                this.activeFilters
        },
    },
    watch: {
        confirmAccepted: function (to) {
            if (this.confirmKey === 'putNoticeTypes') {
                if (to) this.putNoticeTypes()
            }
            if (this.confirmKey === 'putDictionary') {
                if (to) this.putDictionary()
            }
            if (this.confirmKey === 'deleteDictionary') {
                if (to) this.deleteDictionary()
            }
        }
    },
    methods: {
        ...mapActions({
            showError: 'error/show',
            showConfirm: 'confirm/show',
            showToast: 'toast/show',
            loadModel: 'serviceFunctionDetail/loadModel',
            loadNoticeTypeList: 'serviceFunctionDetail/loadNoticeTypeList',
            initDictionary: 'serviceFunctionDetail/initDictionary',
            initModify: 'serviceFunctionDetail/initModify',
        }),
        ...mapMutations({
            setInputValue: 'serviceFunctionDetail/setInputValue',
        }),
        init () {
            this.loading = true
            this.tableData = $.extend(true, [], this.values.dictionaryModel)
            this.loadNoticeTypeList({})
                .then(res => {
                    this.loading = false
                })
                .catch(error => {
                    this.showError(error || null)
                })
        },
        confirmNoticeTypesData () {
            this.showConfirm({
                key: 'putNoticeTypes',
                title: '',
                body: 'この' + this.functionName + '情報を登録しますか？'
            })
        },
        confirmDictionaryData() {
            this.showConfirm({
                key: 'putDictionary',
                title: '',
                body: this.isRegister ?
                    'この内容で' + this.functionName + 'を登録しますか？' :
                    this.functionName + '情報を変更しますか？'
            })
        },
        putNoticeTypes () {
            let noticeTypes = this.inpNoticeTypes
            let dictionary = this.values.soundBroadcastSetting.dictionary
            this.putData(noticeTypes,dictionary,'putNoticeTypes')
        },
        putDictionary () {
            const noticeTypes = this.values.soundBroadcastSetting.noticeTypes
            const dictionaryModel = this.values.dictionaryModel
            let newDictionaryModel = []
            if (dictionaryModel.length > 0) {
                newDictionaryModel = JSON.parse(JSON.stringify(dictionaryModel))
            }
            if (this.isRegister){
                newDictionaryModel.push({
                    word:this.inpWord,
                    ruby:this.inpRuby
                })
            }else{
                newDictionaryModel[this.modifyTargetId-1] = {
                    word:this.inpWord,
                    ruby:this.inpRuby
                }
            }
            this.putData(noticeTypes,newDictionaryModel,'putDictionary')
        },
        deleteDictionary () {
            let deliveryTypes = this.values.soundBroadcastSetting.deliveryTypes
            let dictionaryModel = this.values.dictionaryModel
            dictionaryModel.splice(this.deleteTargetId-1,1)
            this.putData(deliveryTypes,dictionaryModel,'deleteDictionary')
        },
        putData (noticeTypes,dictionary,key) {
            this.processing = true
            let parameters = {
                serviceUuid: this.serviceUuid,
                serviceFunctionUuid: this.serviceFunctionUuid,
                request: {
                    soundBroadcastSetting: {
                        noticeTypes:noticeTypes,
                        dictionary:dictionary
                    },
                }
            }
            ApiManager.request(
                ['serviceFunction'],
                ['v1ServiceFunctionPut'],
                [parameters])
                .then(res => {
                    let status = Utility.parseResponse(res)
                    if (status.result) {
                        // toast
                        let title = ''
                        let body = ''
                        if (key === 'putNoticeTypes') {
                            title = '新しい' + this.functionName + 'の登録'
                            body = this.functionName + 'を登録しました。'
                        }
                        if (key === 'putDictionary' && !this.isRegister) {
                            title = this.functionName + '情報の変更'
                            body = this.functionName + 'を変更しました。'
                            this.dictionaryItem()
                        }else{
                            title = '新しい' + this.functionName + 'の登録'
                            body = this.functionName + 'を登録しました。'
                        }
                        if (key === 'deleteDictionary') {
                            title = this.functionName + '情報の削除'
                            body = this.functionName + 'を削除しました。'
                        }
                        this.showToast({
                            title: title,
                            body: body,
                        })
                        this.modifyTargetId = null
                        this.deleteTargetId = null
                        this.serviceFunctionItem()
                    } else if (status.error) {
                        this.processing = false
                        this.showError(res)
                    } else {
                        this.processing = false
                        this.showError(null)
                    }
                })
                .catch(error => {
                    this.processing = false
                    this.showError(null)
                })
        },
        turnBack () {
            this.$router.push({
                name: 'ServiceFunction',
                params: {
                    serviceId: this.serviceUuid
                }
            })
        },
        serviceFunctionItem () {
            let functionParams = {
                serviceUuid: this.serviceUuid,
                serviceFunctionUuid: this.serviceFunctionUuid
            }
            // データ読出し
            this.loadModel({
                functionParams: functionParams
            })
            .then(res => {
                this.processing = false
                this.tableData = $.extend(true, [], this.values.dictionaryModel)
            })
            .catch(error => {
                this.processing = false
                this.showError(error || null)
            })
        },
        toggleFilters () {
            this.activeFilters = !this.activeFilters
        },
        changePerPage () {
            this.$refs.table.setLimit(this.filterPerPage)
        },
        changePage () {
            // console.log(this.$refs.table.page)
        },
        modifyItem (props) {
            this.modifyTargetId = props.index
            this.initModify({
                data: props.row
            })
        },
        deleteItem (props) {
            this.deleteTargetId = props.index
            this.showConfirm({
                key: 'deleteDictionary',
                title: '',
                body: this.functionName + 'を削除しますか？',
                acceptLabel: '削除'
            })
        },
        dictionaryItem () {
            this.initDictionary()
        },
    }
}
